
export default {
    name: "popup_feedback",
    data(){
        return {
            isLoading: false,
            selectedLang: "en",

            data: {},
            defaultData: {
                location: "",
                entity: "",
                q3: [],
                q4: "",
                q5: "",
                q6: "",
                q7: [],
                q8: "",
                q9: "",
                q10: [],
                q10_0_specify: "",
                q10_1_specify: "",
                q10_4_specify: "",
                q11: [],
                q11_specify: "",
                q12: [],
                q12_specify: "",
                q13: "",
            },

            langText: {
                en: {
                    title: "OCBC MyWellness Fiesta 2026 Post-event Survey",
                    select_one: "Please select one",
                    q1: "Please indicate your location.",
                    q2: "Please indicate your entity.",
                    q3: "How did you learn about OCBC MyWellness Fiesta 2026?",
                    q4: "How would you rate your overall experience?",
                    q5: "Please estimate the number of workshops / webinars you attended throughout the course of the event.",
                    q6: "Do you find the workshops and resources practical and useful to better your well-being?",
                    q7: "Which of the features did you enjoy the most? Please select your top 3, with 1 being your most preferred option.",
                    q8: "Would you be interested in attending MyWellness Fiesta next year?",
                    q9: "Would you recommend your colleagues to participate in the MyWellness Fiesta?",
                    q10: "What changes or additions to the MyWellness Fiesta would make you more likely to recommend it to your colleagues?",
                    q11: "What would you like to see more of in the next MyWellness Fiesta?",
                    q12: "What would you prefer to see less of in the next MyWellness Fiesta?",
                    q13: "Are there new functions or topics that would get you to recommend MyWellness Fiesta to colleagues in the future? Please specify.",
                    submit: "SUBMIT",
                    submit_success: "Thank you for your feedback!",
                    error_required: "All fields are required!",
                },
                cn: {
                    title: "",
                    select_one: "下拉列表",
                    q1: "",
                    q2: "",
                    q3: "",
                    q4: "",
                    q5: "",
                    q6: "",
                    q7: "",
                    q8: "",
                    q9: "",
                    q10: "",
                    q11: "",
                    q12: "",
                    q13: "",
                    submit: "提交",
                    submit_success: "感谢您的反馈意见！",
                    error_required: "请填写所有资料。",
                }
            },

            locations: ["Singapore", "Australia", "China", "Dubai", "Hong Kong", "Indonesia", "Japan", "Korea", "London", "Macau", "Malaysia", "Myanmar", "Philippines", "Taiwan", "Thailand", "London", "United States", "Vietnam"],
            entities: [
                { name: "Bank of Singapore Limited", countries: ["Singapore"] },
                { name: "Bank of Singapore Limited (Hong Kong Branch)", countries: ["Hong Kong"] },
                { name: "Bank of Singapore Limited (Philippine Representative Office)", countries: ["Philippines"] },
                { name: "Bank of Singapore Limited, DIFC Branch", countries: ["Dubai"] },
                { name: "BOS Trustee Ltd", countries: ["Singapore"] },
                { name: "BOS Wealth Management Europe, UK Branch", countries: ["London"] },
                { name: "BOS Wealth Management Malaysia Berhad", countries: ["Malaysia"] },
                { name: "e2 Power (M) Sdn Bhd", countries: ["Malaysia"] },
                { name: "Great Eastern General Indonesia", countries: ["Indonesia"] },
                { name: "Great Eastern Life Indonesia", countries: ["Indonesia"] },
                { name: "Great Eastern Malaysia", countries: ["Malaysia"] },
                { name: "Great Eastern Singapore", countries: ["Singapore"] },
                { name: "Great Eastern Takaful Berhad", countries: ["Malaysia"] },
                { name: "OCBC Al-Amin Bank Berhad", countries: ["Malaysia"] },
                { name: "OCBC Singapore", countries: ["Singapore"] },
                { name: "OCBC Bank", countries: ["Thailand", "Vietnam", "Hong Kong", "Korea", "Australia", "Taiwan", "Japan", "London", "United States", "Myanmar"] },
                { name: "OCBC Capital (Shanghai) Equity Investment Management", countries: ["China"] },
                { name: "OCBC China", countries: ["China"] },
                { name: "e2 Power (Shenzhen) Company Limited", countries: ["China"] },
                { name: "e2 Power (Shenzhen) Company Limited Shanghai Branch", countries: ["China"] },
                { name: "OCBC Labuan Branch", countries: ["Malaysia"] },
                { name: "OCBC Malaysia", countries: ["Malaysia"] },
                { name: "OCBC Overseas Investments Pte. Ltd.", countries: ["Singapore"] },
                { name: "OCBC Property Services Private Limited", countries: ["Singapore"] },
                { name: "OCBC Yuanshen Properties (Shanghai) Company Limited", countries: ["China"] },
                { name: "OCBC Bank (Hong Kong) Limited", countries: ["Hong Kong"] },
                { name: "OCBC Bank (Macau) Limited", countries: ["Macau"] },
                { name: "OCBC Indonesia", countries: ["Indonesia"] },
                { name: "Lion Global Investors", countries: ["Singapore"] },
            ],

            q3Options: [
                {
                    en: "Through MyWellness Champions", 
                    cn: "" 
                } ,
                {
                    en: "Through emails from Group HR", 
                    cn: "" 
                } ,
                {
                    en: "Through intranet / HIP banners", 
                    cn: "" 
                } ,
                {
                    en: "Through physical events", 
                    cn: "" 
                } ,
                {
                    en: "Through my manager / HOD", 
                    cn: "" 
                } ,
                {
                    en: "Through my colleagues", 
                    cn: "" 
                } ,
                {
                    en: "Through social media posts", 
                    cn: "" 
                } ,
            ],
            q4Options: [
                {
                    en: "Extremely satisfied", 
                    cn: "" 
                } ,
                {
                    en: "Somewhat satisfied", 
                    cn: "" 
                } ,
                {
                    en: "Neutral", 
                    cn: "" 
                } ,
                {
                    en: "Somewhat dissatisfied", 
                    cn: "" 
                } ,
                {
                    en: "Extremely dissatisfied", 
                    cn: "" 
                } ,
            ],
            q5Options: [
                {
                    en: "0", 
                    cn: "" 
                } ,
                {
                    en: "1 – 5", 
                    cn: "" 
                } ,
                {
                    en: "6 – 10", 
                    cn: "" 
                } ,
                {
                    en: "11 – 20", 
                    cn: "" 
                } ,
                {
                    en: "> 20", 
                    cn: "" 
                } ,
            ],
            q6Options: [
                {
                    en: "Extremely useful", 
                    cn: "" 
                } ,
                {
                    en: "Somewhat useful", 
                    cn: "" 
                } ,
                {
                    en: "Not useful", 
                    cn: "" 
                } ,
            ],
            q7Options: [
                {
                    en: "Wellness Talks", 
                    cn: "" 
                } ,
                {
                    en: "GET MOVING fitness sessions", 
                    cn: "" 
                } ,
                {
                    en: "Downloadable Resources (Conversations That Connect, The Daily Movement Setlist, My Reset Toolkit)", 
                    cn: "" 
                } ,
                {
                    en: "Games (Build the Beat)", 
                    cn: "" 
                } ,
                {
                    en: "Fiesta Jukebox", 
                    cn: "" 
                } ,
                {
                    en: "Scavenger Hunt", 
                    cn: "" 
                } ,
                {
                    en: "The Chat Area (Vibe Chat)", 
                    cn: "" 
                } ,
            ],
            q10Options: [
                {
                    en: "More diverse wellness activities (please specify)", 
                    cn: "" 
                } ,
                {
                    en: "Opportunities for team bonding or group challenges (please specify)", 
                    cn: "" 
                } ,
                {
                    en: "Simpler registration or sign-up process", 
                    cn: "" 
                } ,
                {
                    en: "Attractive rewards or incentives for participation", 
                    cn: "" 
                } ,
                {
                    en: "Others (please specify)", 
                    cn: "" 
                } ,
            ],
            q11Options: [
                {
                    en: "Physical Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Mental Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Family Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Financial Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Wellness at Workplace talks", 
                    cn: "" 
                } ,
                {
                    en: "GET MOVING fitness sessions", 
                    cn: "" 
                } ,
                {
                    en: "Games", 
                    cn: "" 
                } ,
                {
                    en: "Downloadable resources", 
                    cn: "" 
                } ,
                {
                    en: "Others (please specify)", 
                    cn: "" 
                } ,
            ],
            q12Options: [
                {
                    en: "Physical Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Mental Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Family Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Financial Wellness talks", 
                    cn: "" 
                } ,
                {
                    en: "Wellness at Workplace talks", 
                    cn: "" 
                } ,
                {
                    en: "GET MOVING fitness sessions", 
                    cn: "" 
                } ,
                {
                    en: "Games", 
                    cn: "" 
                } ,
                {
                    en: "Downloadable resources", 
                    cn: "" 
                } ,
                {
                    en: "Others (please specify)", 
                    cn: "" 
                } ,
            ],

            yesNoOptions: [
                {
                    en: "Yes",
                    cn: "是",
                },
                {
                    en: "No",
                    cn: "否",
                }
            ],
        }
    },
    computed: {
        locationEntities(){
            if(!this.data.location) return [];

            const filterItems = _.filter(this.entities, entity => {
                return entity.countries.includes(this.data.location);
            });

            return _.map(filterItems, "name");
        }
    },
    mounted(){
        this.onInitData();
    },
    methods: {
        onInitData(){
            $("#image_input").val("");
            this.data = { ...this.defaultData };
            this.data.q7 = [];
            if(this.locations.includes(this.user.location)) this.data.location = this.user.location;
            if(this.locationEntities.includes(this.user.entity)) this.data.entity = this.user.entity;
        },
        getQ7OptionLabel(item){
            const index = this.data.q7?.indexOf(item.en);
            if(index > -1) return `[${ index + 1 }] ${ item[this.selectedLang] }`
            return item[this.selectedLang];
        },
        onChangeQ7Checkbox(item){
            if(this.data.q7?.includes(item)){
                this.data.q7 = this.data.q7.filter(answer => answer !== item);
            }else if(this.data.q7.length < 3){
                this.data.q7.push(item);
            }
        },
        onClickSubmitBtn(){
            if(!this.isLoading){
                this.isLoading = true;

                this.onHandleTriggerAnalytics(`submit@feedback`); 
    
                const tempData = { ...this.data };
                try{
                    for(const key in tempData){
                        if(!tempData[key] && !key.includes("_specify")) throw new Error("");
                        if(["q3", "q7", "q10", "q11", "q12"].includes(key)){
                            if(tempData[key].length < 1) throw new Error("");

                            if(key == "q10"){
                                this.q10Options.forEach((option, index) => {
                                    if(option.en.includes("(please specify)") && this.data.q10.includes(option.en)){

                                        if(!tempData[`${ key }_${ index }_specify`]) throw new Error("");
                                        tempData[key] = tempData[key].map(item =>
                                            item === option.en? option.en.replace("please specify", tempData[`${ key }_${ index }_specify`]) : item
                                        );
                                    }
                                })
                            }else if(["q11", "q12"].includes(key)){
                                if(tempData[key].includes("Others (please specify)")){
                                    if(!tempData[`${ key }_specify`]) throw new Error("");
                                    tempData[key] = tempData[key].map(item =>
                                        item === "Others (please specify)"? `Others (${ tempData[`${ key }_specify`] })` : item
                                    );
                                }
                            }
                        }

                    }
                }catch(err){
                    this.isLoading = false;
                    return this.$swal({ icon: "info", title: this.langText[this.selectedLang].error_required });
                }

                this.$axios.$post("/feedback", tempData, this.tokenHeader).then((res) => {
                    console.log("submitFeedbackCallback", res);

                    if(res.stamp) this.$store.commit("stamp/addItem", res.stamp);

                    this.onInitData();
                    this.isLoading = false;
                    this.$swal({ icon: "success", title: this.langText[this.selectedLang].submit_success });
                }).catch((err) => {
                    console.error("submitFeedbackError", err);
                    this.isLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@feedback`); 
        },
    },
    watch: {
        "data.location"(){
            if(!this.locationEntities.includes(this.user.entity)) this.data.entity = "";
        },
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@feedback`); 
        }
    }
}
